export default {
  NORMAL: "TABLE_NORMAL_ROW",
  EMPTY: "TABLE_EMPTY_ROW"
};
